<template>
  <BaseScreen v-bind="screen">
    <Instruction
      v-bind="instruction"
      class="screen__stretch screen__offset-right"
    />
  </BaseScreen>
</template>

<script>
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import Instruction from '@/components/Instruction.vue';

export default {
  name: 'VideoInstructionScreen',
  mixins: [screenMixin],
  components: {
    Instruction,
  },
  computed: {
    screenCase() {
      return CONSTANTS.STEP_VIDEO_INSTRUCTION;
    },
    instruction() {
      return {
        title: {
          text: this.$t('titles.videoFeedbackQuality'),
          size: 'l',
          isNormal: true,
        },
        description: {
          text: this.$t('texts.videoInstruction'),
          size: 'l',
        },
        button: {
          text: this.$t('actions.start'),
          action: this.goToVideoRecordingScreen,
        },
        imageName: 'video.png',
      };
    },
  },
  created() {
    this.initActions([
      [CONSTANTS.ACTION_CONTINUE, this.goToVideoRecordingScreen],
    ]);
  },
  methods: {
    goToVideoRecordingScreen() {
      this.$router.push(this.$router.options.paths.videoRecording);
    },
  },
};
</script>
